import './Footer.css';
import NiceModal from '@ebay/nice-modal-react';
import LogoutModal from '/src/features/auth/components/LogoutModal/LogoutModal';
import { useNavigate } from 'react-router-dom';
import { useAuthStateContext } from '/src/features/auth/context/authContext';
import { useAuthDispatchContext } from '/src/features/auth/context/authContext';
import { NavLink } from 'react-router-dom';
import { removeStorageParam } from '../../../../utils/storageParam';
import { clearAuthStorage } from '/src/features/auth/utils/authStorage';

function Footer() {

    const { user } = useAuthStateContext();

    const naviguate = useNavigate()
    const dispatch = useAuthDispatchContext();

    const showLogoutModal = () => NiceModal.show(LogoutModal).then(() => {
        removeStorageParam('conversation_filters');
        clearAuthStorage();
        dispatch({ type: 'loginOut' });
        naviguate('/login')
    })

    return (
        <div className="footer">

            <div className="user">

                <NavLink to="/account/profile" className="user-profile-link" title="My profile">
                    <div className="user-avatar">
                        <i className="fa-solid fa-user"></i>
                    </div>
                    <span>{user?.email}</span>
                </NavLink>

                {!user?.external_id && (
                    <button id="sidebar-disconnect">
                        <div className='svg logout' onClick={showLogoutModal}></div>
                    </button>
                )}
            </div>

        </div>
    )
}

export default Footer;